export const logError = async (error) => {
    console.log(error);

    try {
        const Sentry = await import('@sentry/react');
        
        // Add context for enhanced errors
        if (error.apiContext) {
            Sentry.withScope((scope) => {
                scope.setContext('API Request', error.apiContext);
                scope.setTag('error_type', 'api_error');
                scope.setTag('api_method', error.apiContext.method);
                scope.setTag('api_endpoint', error.apiContext.path);
                
                if (error.apiContext.status) {
                    scope.setTag('http_status', error.apiContext.status);
                }
                
                Sentry.captureException(error);
            });
        } else if (error.context) {
            Sentry.withScope((scope) => {
                scope.setContext('Request Context', error.context);
                scope.setTag('error_type', 'external_api_error');
                scope.setTag('function_name', error.context.function);
                
                if (error.context.status) {
                    scope.setTag('http_status', error.context.status);
                }
                
                Sentry.captureException(error);
            });
        } else {
            Sentry.captureException(error);
        }
    } catch (importError) {
        console.error('Sentry import failed:', importError);
    }
};
